import $ from "jquery";

import "bootstrap";
import responsiveBootstrapToolkit from "responsive-toolkit";

window.ResponsiveBootstrapToolkit = responsiveBootstrapToolkit;

import "metismenu";
import "metismenu/dist/metisMenu.min.css";

import "animate.css/animate.min.css";

import "jquery-touchswipe";
import "jquery-validation";
import "jquery-validation-unobtrusive";
import "jquery.browser";

import "quill";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import "tinycolor2";

import "chart.js";

import "promise-polyfill/src/polyfill";
import "isomorphic-fetch";

import {JL} from 'jsnlog';

window.jQuery = $;
window.$ = $;